import { useEffect, useState } from 'react';

import { Icon, IconButton, Modal, TextField } from '@atom/mui';
import { FormatAlignLeftIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { CiModuleInspection } from '@atom/types/form';

export interface Props {
  inspection: CiModuleInspection;
  onSubmit: (comments: string) => void;
  preview: boolean;
  isWorkOrderClosed: boolean;
  isEditable: boolean;
}

const CiCommentsModal = ({
  inspection,
  onSubmit,
  preview,
  isWorkOrderClosed,
  isEditable,
}: Props) => {
  const [open, setOpen] = useState<boolean>(false);
  const [comments, setComments] = useState<string>('');

  useEffect(() => {
    setComments(inspection.comments || '');
  }, [inspection, open]);

  const handleSubmit = () => {
    if (!preview && isEditable) {
      onSubmit(comments);
    }

    setOpen(false);
  };

  const hasComments = preview ? comments : inspection.comments;

  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        <Icon
          color={hasComments ? colors.brand.blue : colors.neutral.gray}
          icon={FormatAlignLeftIcon}
        />
      </IconButton>
      <Modal
        open={open}
        title="Notes"
        onConfirm={handleSubmit}
        onCancel={() => setOpen(false)}
        confirmButtonText="Save"
        disabled={isWorkOrderClosed || !isEditable}
      >
        <TextField
          fullWidth
          multiline
          key="name"
          value={comments}
          onChange={event => setComments(event.target.value)}
          disabled={isWorkOrderClosed || !isEditable}
        />
      </Modal>
    </>
  );
};

export default CiCommentsModal;
